import {
  Stack,
} from '@mui/material';
import PickupDeliveryInput from 'components/PickupDeliveryInput';
import React from 'react';
import SearchLocationInput from './SearchLocationInput';

function Filters({
  value, onChange, onSelectingLocation, ...props
}) {
  return (
    <Stack
      p={2}
      pt={0}
      gap={1.5}
      sx={{ borderRadius: 0 }}
      {...props}
    >

      <SearchLocationInput
        value={value?.center}
        onChange={(center) => onChange({ ...value, center })}
        onSelectingLocation={onSelectingLocation}
      />
      <PickupDeliveryInput
        hasDelivery={value.hasDelivery}
        onChange={(hasDelivery) => onChange({ ...value, hasDelivery })}
        deliveryText="Catering Delivery"
        pickupText="Catering Pickup"
        size="small"
      />
    </Stack>
  );
}

export default Filters;
